<template>
  <ul class="content_tab" ref="categoriesTab">
    <li
      v-for="category in categories"
      v-bind:class="[
        'content_tab_' + category.title,
        { active: isActive(category.id) },
      ]"
      v-bind:id="category.title"
      v-bind:key="category.id"
    >
      <a
        v-on:click="clickTab(category.title)"
      >
        <LabelFunMessage
          v-bind:fcontId="getLabelId(category)"
          v-bind:msgkey="getLabelKey(category)"
        />
      </a>
    </li>
  </ul>
</template>

<script>
import { mapState } from "vuex";
import LabelFunMessage from "./LabelFunMessage";

export default {
  name: "CategoryTabs",
  props: {
    selectedCategoryId: Number,
  },
  components: {
    LabelFunMessage,
  },
  computed: {
    ...mapState(["categories","lg2"]),
  },
  methods: {
    categoryTitle: function (categoryId) {
      if (this.categories == []) {
        return "";
      } else {
        const category = this.categories.find(
          function (category) {
            return category.id == categoryId;
          }.bind(this)
        );
        return category.title;
      }
    },
    getLabelId: function (category) {
      return category.label.split("-")[0];
    },
    getLabelKey: function (category) {
      return category.label.split("-")[1];
    },
    isActive: function (categoryId) {
      return this.selectedCategoryId == categoryId;
    },
    clickTab: function (categoryTitle) {
      // GA4
      this.$gtag.event("tap_button", {
        "custom_parameter1": "category_tab",
        "custom_parameter2": categoryTitle
      })

      this.$router.push({ 
        path: '/' + this.lg2 + '/categories/' + categoryTitle,
        query: { EXE: this.$route.query.EXE, locale: this.$route.query.locale } 
      })
    },
  },
  mounted: function () {
    // 選択済みのカテゴリを中央に表示
    let tabElement = this.$refs.categoriesTab.firstElementChild;
    let targetElement;
    while (tabElement) {
      const categoryTitle = tabElement.getAttribute("id");
      if (categoryTitle == this.categoryTitle(this.selectedCategoryId)) {
        targetElement = tabElement;
        break;
      }
      tabElement = tabElement.nextElementSibling;
    }
    const leftPos =
      targetElement.getBoundingClientRect().left -
      window.innerWidth / 2.0 +
      targetElement.getBoundingClientRect().width / 2.0;
    this.$refs.categoriesTab.scrollLeft = leftPos;
  },
  metaInfo() {
    return {
      link: [
        { rel: 'stylesheet', href: process.env.VUE_APP_ROOT + '/assets/common/css/category_tabs.css' }
      ]
    }
  } 
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
